import { api_configuration } from "../../common";
import client_request_decorator = api_configuration.libraries.gui_definition_lib.libraries.model_lib.types.client_request.alan_api;
import ConditionalChildPathBuilder = require("./createConditionalChildPathBuilder");

type Builder = (
	head: client_request_decorator.Tconditional_child_path,
	tail: client_request_decorator.Tcollection_query_path
) => client_request_decorator.Tcollection_query_path;

export class CollectionPathBuilder {
	build_steps: { builder: Builder; head: ConditionalChildPathBuilder }[];
	head: ConditionalChildPathBuilder;

	constructor(
		build_steps: { builder: Builder; head: ConditionalChildPathBuilder }[] = [],
		head_builder = new ConditionalChildPathBuilder()
	) {
		this.build_steps = build_steps;
		this.head = head_builder;
	}

	static create(): CollectionPathBuilder {
		return new CollectionPathBuilder();
	}

	addConditionalStep(new_head_builder: ConditionalChildPathBuilder): CollectionPathBuilder {
		return new CollectionPathBuilder(this.build_steps, new_head_builder);
	}

	newBuilder(build_function: Builder): CollectionPathBuilder {
		return new CollectionPathBuilder(
			this.build_steps.slice(0).concat({
				builder: build_function,
				head: this.head,
			})
		);
	}

	group(group: string): CollectionPathBuilder {
		return this.addConditionalStep(this.head.group(group));
	}

	state(state_group: string, state: string): CollectionPathBuilder {
		return this.addConditionalStep(this.head.state(state_group, state));
	}

	collection(collection: string): CollectionPathBuilder {
		return this.newBuilder(function (head, tail) {
			return {
				"has steps": [
					"yes",
					{
						head: head,
						collection: collection,
						type: ["existing entries", {}],
						tail: tail,
					},
				],
			};
		});
	}

	candidates(collection: string): CollectionPathBuilder {
		return this.newBuilder(function (head, tail) {
			return {
				"has steps": [
					"yes",
					{
						head: head,
						collection: collection,
						type: [
							"candidates",
							{
								delink: {
									delink: ["yes", {}],
								},
								"include reference": ["yes", {}],
							},
						],
						tail: tail,
					},
				],
			};
		});
	}

	build(): client_request_decorator.Tcollection_query_path {
		return this.build_steps
			.slice()
			.reverse()
			.reduce<client_request_decorator.Tcollection_query_path>(
				function (tail, build_step) {
					return build_step.builder(build_step.head.build(), tail);
				},
				{ "has steps": ["no", {}] }
			);
	}
}
